module.exports = __webpack_public_path__ + "img/warning-icons.00572b16.svg";